import { Spacer } from '@zillow/constellation';
import { FormField, FormHelp, Label, LabeledControl, Radio, Text, Textarea } from '@zillow/constellation-10';

import { deactivationReasons, REASONS } from '../constants';

const DeactivationReason = ({ onReasonSelection, reason, onFeedbackChange }) => {
  return (
    <>
      <Spacer marginBottom="xs">
        <Text textStyle="heading-xs">Why are you deactivating this listing?</Text>
      </Spacer>
      <Spacer marginBottom="xs">
        <Text>Your answer helps us direct you to the right next step.</Text>
      </Spacer>
      {deactivationReasons.map((option) => (
        <LabeledControl
          key={option.name}
          label={<Label>{option.label}</Label>}
          control={
            <Radio
              name={option.name}
              onChange={() => onReasonSelection(option.name)}
              checked={reason === option.name}
            />
          }
        />
      ))}
      {reason === REASONS.OTHER && (
        <>
          <Spacer marginBottom="xxs">
            <Text textStyle="body-sm-bold" asChild>
              <span>Add details</span>
            </Text>
            <Text> (optional)</Text>
          </Spacer>
          <FormField>
            <Textarea maxLength="500" onChange={onFeedbackChange} />
            <FormHelp>Max 500 characters</FormHelp>
          </FormField>
        </>
      )}
    </>
  );
};

export default DeactivationReason;
